import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=4cbf0ffb&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf0ffb",
  null
  
)

export default component.exports